module.exports = __webpack_public_path__ + "img/souldy-icon-1.1d2f8e66.jpg";